/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Online_IncludeInputs */



/**
* | output |
* | --- |
* | "Include" |
*
* @param {Tournaments_Online_IncludeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_online_include = /** @type {((inputs?: Tournaments_Online_IncludeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Online_IncludeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inclure")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incluir")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Incluir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Includi")
	return /** @type {LocalizedString} */ ("Include")
});